"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Numbers = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Numbers.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Numbers = function Numbers(_ref) {
  var total = _ref.total,
    current = _ref.current,
    surrounding = _ref.surrounding,
    onClick = _ref.onClick,
    className = _ref.className;
  var clickHandler = (0, _react.useCallback)(function (number) {
    return function () {
      return onClick(number);
    };
  }, [onClick]);
  var buildPageLink = (0, _react.useCallback)(function (number) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: number,
      className: (0, _classnames["default"])('cds-Pagination-NumbersPage', {
        'cds-Pagination-NumbersPage--Active': current === number
      })
    }, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: clickHandler(number),
      className: "cds-Link cds-Pagination-Link"
    }, number));
  }, [clickHandler, current]);
  var start, end;
  switch (true) {
    case current <= surrounding:
      start = Math.max(current - surrounding, 1);
      end = start + 2 * surrounding;
      break;
    case current + surrounding > total:
      end = Math.min(current + surrounding, total);
      start = end - 2 * surrounding;
      break;
    default:
      start = current - surrounding;
      end = current + surrounding;
      break;
  }
  start = Math.max(start, 1);
  end = Math.min(end, total);
  var pages = [];
  if (start > 1) {
    pages.push(buildPageLink(1));
  }
  if (start > 2) {
    pages.push( /*#__PURE__*/_react["default"].createElement("li", {
      key: "left-separator",
      className: "cds-Pagination-NumbersSeparator"
    }, "..."));
  }
  for (var page = start; page <= end; page++) {
    pages.push(buildPageLink(page));
  }
  if (end < total - 1) {
    pages.push( /*#__PURE__*/_react["default"].createElement("li", {
      key: "right-separator",
      className: "cds-Pagination-NumbersSeparator"
    }, "..."));
  }
  if (end < total) {
    pages.push(buildPageLink(total));
  }
  return /*#__PURE__*/_react["default"].createElement("ol", {
    className: (0, _classnames["default"])('cds-Pagination-Numbers', className)
  }, pages);
};
exports.Numbers = Numbers;